


















import { Component, Vue, Prop } from 'vue-property-decorator';

interface IConversationFilters {
  unread: boolean;
  pinned: boolean;
  unassigned: boolean;
}

@Component({
  name: 'GeoChatConversationsFiltersBar',
})
export default class GeoChatConversationsFiltersBar extends Vue {
  @Prop({ required: true })
  filters!: IConversationFilters;

  @Prop({ default: 0 })
  unreadCount!: number;

  toggleFilter(filterName: string) {
    this.$emit('filter-change', filterName, !this.filters[filterName]);
  }
}
